import React from 'react';
import {withRouter} from 'react-router-dom';

import {Payments} from 'components/common/app';
import {CardContainer, Notification, Button, Loading, ConfirmDialog} from 'components/common/uiKit';

import {serverUrl} from 'services/network';
import {CourseApi} from 'services/network/api';
import {connect} from "react-redux";

var jMoment = require('moment-jalaali');

class InfoTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            courseId: props.id,
            data: undefined,
            loading: true,
            btnLoading: false,
            showRuleDialog: false,
            modalConfirmAgreeLoading: false,
            paymentType: 'Online'
        };
    }

    componentDidMount() {
        const {courseId} = this.props;
        this.loadData(courseId);
    }

    async loadData(courseId) {
        if (courseId) {
            CourseApi.GetDetails(courseId)
                .then(res => {
                    if (res && res.status == 200) {
                        const {data} = res;
                        this.setState({data});
                    }
                }).finally(() => {
                this.setState({loading: false});
            });
        }
    }

    register = () => {
        this.setState({showRuleDialog: true});
    };

    agreeWithRules = () => {
        const {courseId} = this.props;
        const {paymentType} = this.state;
        if (courseId) {
            this.setState({modalConfirmAgreeLoading: true});

            switch (paymentType.toLowerCase()) {
                case 'online':
                    const _data = {id: parseInt(courseId)};
                    CourseApi.Register(_data)
                        .then(res => {
                            if (res && res.status == 200) {
                                window.location = res.data.paymentUrl;
                            }
                        }).finally(() => {
                        this.setState({modalConfirmAgreeLoading: false});
                    });
                    break;
                case 'offline':
                    const {history} = this.props;
                    history.push({
                        pathname: `courseRegistration?courseId=${courseId}`,
                        //search: `?lessonId=${id}`,
                        //state: {...data}
                    });
                    break;
            }
        }
    };

    paymentOnChange = (data) => {
        this.setState({paymentType: data.key});
    };

    handleRegistrationType = () => {
        const {data} = this.state;
        const {registrationType, courseRegisterDate, time} = data;
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Course.Info;

        const renewalDate = jMoment(courseRegisterDate).format('jYYYY/jMM/jDD - HH:mm');
        const expireDate = jMoment(new Date(courseRegisterDate).setDate(new Date(courseRegisterDate).getDate() + time)).format('jYYYY/jMM/jDD - HH:mm');

        switch (registrationType) {
            case 1:
                return (
                    <>
                        <span>{pageTranslates.RegisterDate}: {renewalDate}</span>
                        <strong>{pageTranslates.ExpireDate}: {expireDate}</strong>
                    </>
                );
            case 3:
                return (
                    <>
                        <span>{pageTranslates.RegisterDate}: {renewalDate}</span>
                        <strong>{pageTranslates.ExpireDate}: {expireDate}
                            <small className='font-9 text-danger mr-2'>{pageTranslates.Expired}</small>
                        </strong>
                    </>
                );
            default:
                return (
                    <>
                        <span>{pageTranslates.NotRegistered}</span>
                        <strong>{pageTranslates.ExpireDate}:{time} {pageTranslates.Days} </strong>
                    </>
                );
        }
    };

    render() {
        const {data, btnLoading, loading, showRuleDialog, modalConfirmAgreeLoading} = this.state;

        if (!data || data.length == 0 || loading) {
            return (
                <Loading/>
            );
        }


        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Course.Info;

        const imageUrl = `${serverUrl}${data.image.split('\\').join('/')}`;
        const {title, price, renewalPrice, summary, description, registrationType, time, courseRegisterDate, totalLevels, passedLevels} = data;


        return (
            <>
                <CardContainer disablePadding>
                    <img src={imageUrl} className="preload-img img-fluid bottom-20 w-100"/>
                    {registrationType == 3 ?
                    <div className="alert m-2 rounded-s bg-red2-dark " role="alert">
                        <small className="alert-icon-text">
                            {pageTranslates.ExpiredDescription}
                        </small>
                    </div> : ''
                    }
                    <div className="content mb-0">
                        <h1>{title}</h1>
                        <p className="font-11 font-weight-bold color-highlight mb-0 mt-1">
                            {summary}
                        </p>

                        <div className="list-group list-custom-large mb-4">
                            <a>
                                <i className="far fa-calendar color-blue2-dark"></i>
                                {this.handleRegistrationType()}
                            </a>
                            <a>
                                <i className="fa fa-file-alt color-red2-dark"></i>
                                <span>{pageTranslates.TotalLevels}: {totalLevels} {pageTranslates.Levels}</span>
                                <strong>{pageTranslates.PassedLevels}: {passedLevels} {pageTranslates.Levels}</strong>
                            </a>
                            <a>
                                <i className="fa fa-ticket-alt color-green1-dark"></i>
                                <span>{pageTranslates.Price}: {price.toLocaleString()} {pageTranslates.Currency}</span>
                                <strong>{pageTranslates.RenewalPrice}: {renewalPrice.toLocaleString()} {pageTranslates.Currency}</strong>
                            </a>
                        </div>

                        <h4>
                            {pageTranslates.Description}
                        </h4>
                        <p className="mb-4 text-justify">
                            {description}
                        </p>

                        {registrationType != 1 &&
                        <>
                            <Payments onChange={this.paymentOnChange}/>
                            <Button title={pageTranslates.Register} full type='primary' shadowType='xl'
                                    onClick={this.register}
                                    classes="font-900 mb-3 font-900" loading={btnLoading}>
                            </Button>
                        </>
                        }
                    </div>
                </CardContainer>

                <ConfirmDialog open={showRuleDialog}
                               title={pageTranslates.Policy}
                               content={pageTranslates.PolicyContent}
                               agreeText={pageTranslates.AgreePolicy}
                               agreeLoading={modalConfirmAgreeLoading}
                               onAgree={this.agreeWithRules}
                               onCancel={() => this.setState({showRuleDialog: false})}
                />
            </>
        );
    }

}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(InfoTab));

